import React, { useState, useEffect } from "react";
import { Spinner, MrSelect } from "mr_react_framework";
import { useDispatch, useSelector } from "react-redux";
import {
  appRegionSelector,
  currentUserSelector,
} from "views/Auth/Login/selector";
import { checkMob, getAPColorPallete } from "lib/utils/helperMethods";
import { Col, Collapse, Row, Space, Statistic, Tag, Typography } from "antd";
import { actions as experienceActions } from "views/Experiences/redux";
import { activeAdjustedExperienceSelector, experienceAnalyticsSummarySelector } from "views/Experiences/selector";
import loadable from "@loadable/component";
import { useTranslate } from "lib/MrTranslate/MrTranslate";

const RCJChart = loadable(() =>
  import(/* webpackChunkName: "react-chart" */ "views/Segments/RCJChart/RCJChart")
);

const SummaryChart = (props) => {
  const { chartData, chartColors } = props
  console.log("ExperienceAnalyticsSummary SummaryChart chartData", chartData)
  const mrIntl = useTranslate()
  let chart_settings = {
    type: "bar",
    // type: "pie",
    // title: "Student performance",
    xAxesLabel: mrIntl("ExperienceAnalyticsSummary.score_range"),
    yAxesLabel: mrIntl("ExperienceAnalyticsSummary.number_of_students"),
    labels: chartData.labels, 
    // datasets: chartData.student_counts,
    // labels: ["10", "20", "30", "40"], // Column headers - week number or month number
    // labels: ["Jan", "Feb", "Mar", "Apr"], // Column headers - week number or month number
    datasets: [ // one object for each data row/line graph - one object for single line, multiple for multiple lines
      {
        data: chartData.student_counts, // customers
        label: mrIntl("ExperienceAnalyticsSummary.number_of_students"),
        backgroundColor: chartColors // array for pie/bar if all different needed - TODO: choose better colours
        // backgroundColor: ["red", "blue", "green", "yellow", "orange", "purple"] // array for pie/bar if all different needed
      }
    ],
    showGridLines: false,
    showLegend: false,
    customColors: true, // only supported in bar for now
    // stacked: true,
    // stepSize: 2, // using precision: 0 instead // only supported in bar for now
    
  }

  return <RCJChart chart_settings={chart_settings} />
}

const SummaryDistributionStudentNames = (props) => {
  console.log("SummaryDistributionStudentNames props", props);
  const { chartData, chartColors } = props;
  const { Panel } = Collapse;
  const { Text } = Typography;
  let panelsRender = []
  chartData.labels.forEach((label, i) => {
    let studentNames = chartData.student_names[i]
    let header = <Space><Tag color={chartColors[i]}>{label}</Tag></Space>
    let panel =  <Panel header={header} key="1" showArrow={false}>
      {studentNames ? studentNames.map((name, j) => {
        return name.concat(studentNames.length - 1 !== j ? ", " : "");
      }) : <Text type="secondary">-</Text> }
    </Panel>
    panelsRender.push(panel)  
  })
  let finalRender = <Collapse defaultActiveKey={['1']} collapsible={false}>
    {panelsRender}
  </Collapse>

  return finalRender;
}

const ExperienceAnalyticsSummary = (props) => {
  console.log("ExperienceAnalyticsSummary props ==>", props);
  // const { } = props;
  const dispatch = useDispatch();
  const mrIntl = useTranslate()
  const currentUser = useSelector(currentUserSelector());
  const activeExperience = useSelector(activeAdjustedExperienceSelector());
  const experienceAnalyticsSummaryData = useSelector(experienceAnalyticsSummarySelector());
  const apColors = getAPColorPallete();
  let chartColors = [apColors.red, apColors.red, apColors.red, apColors.lightorange, apColors.lightorange, apColors.lightorange, apColors.green, apColors.green, apColors.green, apColors.blue]

  useEffect(() => {
    dispatch(experienceActions.getAnalytics({experience_id: activeExperience.id, type: "summary"}))
    return () => {
    };
  }, []);

  console.log("ExperienceAnalyticsSummary experienceAnalyticsSummaryData", experienceAnalyticsSummaryData);

  return (
    <React.Fragment>
      {/* {isFirebaseTokenLoading && <Spinner />} */}
      
      <Row gutter={16} style={{"width":"100%", "textAlign":"center", "marginTop":"20px", "marginBottom":"20px"}}>
        <Col span={4}>
          <Statistic title={mrIntl("CommonText.submissions")} value={`${activeExperience.submissions_count}`} />
        </Col>
        <Col span={5}>
          <Statistic title={mrIntl("ExperienceAnalyticsSummary.average")} value={`${experienceAnalyticsSummaryData.average.percentage} %`} />
        </Col>
        <Col span={5}>
          <Statistic title={mrIntl("ExperienceAnalyticsSummary.median")} value={`${experienceAnalyticsSummaryData.median.percentage} %`} />
        </Col>
        <Col span={5}>
          <Statistic title={mrIntl("ExperienceAnalyticsSummary.min")} value={`${experienceAnalyticsSummaryData.min.percentage} %`} />
        </Col>
        <Col span={5}>
          <Statistic title={mrIntl("ExperienceAnalyticsSummary.max")} value={`${experienceAnalyticsSummaryData.max.percentage} %`} />
        </Col>
      </Row>
      {experienceAnalyticsSummaryData.chart_data && <Row>
        <Col span={24} className="m-t-30">
           <SummaryChart chartData={experienceAnalyticsSummaryData.chart_data} chartColors={chartColors}/>
        </Col>
        <Col span={24} className="m-t-30">
          <SummaryDistributionStudentNames chartData={experienceAnalyticsSummaryData.chart_data} chartColors={chartColors}/>
        </Col>
      </Row>}
    </React.Fragment>
  );
};

export default ExperienceAnalyticsSummary;
